@use "ui/styles/sizes";
@use "ui/styles/colors";
@use "ui/styles/fontStyles";

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 999pc;
  white-space: nowrap;
  gap: sizes.$s3;
  border: 1px solid colors.$gray30;
  padding: sizes.$s2 sizes.$s4;
  color: colors.$gray80;
  @include fontStyles.body3-medium;

  .icon {
    color: colors.$gray60;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
